module.exports = __webpack_public_path__ + "img/avatar-user-male.bf227937.svg";